import React from 'react';
import Dialog from '@rio-cloud/rio-uikit/lib/es/Dialog';

interface DeleteSessionDialogProps {
    isOpen: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

const DeleteSessionDialog = ({ isOpen, onConfirm, onCancel }: DeleteSessionDialogProps) => {
    const content = (
        <div className="text-center">
            <div className="margin-50">
                <div className="text-size-h4 margin-bottom-10">
                    Delete conversation
                </div>
                <div className="text-size-14 text-color-gray">
                    Are you sure you want to delete this conversation? This action cannot be undone.
                </div>
            </div>
            <div className="pull-right btn-toolbar">
                <button
                    type="button"
                    className="btn btn-default"
                    onClick={onCancel}
                    data-testid="delete-session-cancel-btn"
                >
                    Cancel
                </button>
                <button
                    type="button"
                    className="btn btn-primary"
                    onClick={onConfirm}
                    data-testid="delete-session-confirm-btn"
                >
                    Confirm
                </button>
            </div>
        </div>
    );

    return (
        <Dialog
            show={isOpen}
            onClose={onCancel}
            useOverflow
            body={content}
        />
    );
};

export default DeleteSessionDialog;
